import { SET_LAST_SELECTED_SIZE } from 'constants/reduxActions';

export const getLastSelectedSize = (lastSelectedSizeObject = {}, gender, dimensionId) => {
  const lastSizesByGender = lastSelectedSizeObject[gender];
  if (lastSizesByGender && lastSizesByGender[dimensionId]) {
    return lastSizesByGender[dimensionId];
  } else {
    return undefined;
  }
};

export const getApproximateSize = (sizeIds, lastSelectedSize, hypercubeSizingData) => {
  if (!lastSelectedSize || !sizeIds || !hypercubeSizingData) {
    return undefined;
  }
  if (sizeIds.find(sizeId => sizeId === lastSelectedSize.sizeId)) {
    return lastSelectedSize.sizeId; // exact match exists
  } else {
    const approximateSize = sizeIds.map(sizeId => {
      // calculate all the overlaps
      const sizeRange = hypercubeSizingData[sizeId];
      const overlap = Math.min(sizeRange.max, lastSelectedSize.max) - Math.max(sizeRange.min, lastSelectedSize.min);
      return { id: sizeId, overlap };
    }).reduce((largest, current) => {
      // find the non-zero max
      if (current.overlap > 0 && current.overlap > largest.overlap) {
        return current;
      } else {
        return largest;
      }
    }, { id : undefined, overlap : -Infinity });

    return approximateSize.id;
  }
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_LAST_SELECTED_SIZE:
      return {
        ...state,
        [action.gender] : {
          ...state[action.gender],
          [action.dimensionId] : {
            sizeId : action.sizeId,
            min : action.min,
            max : action.max
          }
        }
      };
    default:
      return state;
  }
};

export default reducer;
